<template>
    <BarChart v-bind:title="title" v-bind:data="data"/>
</template>

<script>
import BarChart from "@/components/management/statistics/common/BarChart";
import {getAccountCreateChartData} from "@/api/statistics";

export default {
  components: {
    BarChart,
  },
  data() {
    return {
      title : 'Account Create',
      data : [],
    };
  },
  // created() {
  //   this.getData();
  // },
  methods: {
    async getData(year, role) {
      let loader = this.$loading.show({});
      try {
        let response = await getAccountCreateChartData(year, role);
        console.log(response);
        this.data = response.data.result;
      } finally {
        loader.hide();
      }
    },
  }
};
</script>

<style>
</style>
